import axios from 'axios'
import endpoints from './endpoints.js'
import { createRequestData, url, replaceSpace } from './constants.js'

// get item data
const getItem = async (storeId, menuId, categoryId, itemId, payload) => {
  // some store ids have spaces in them. replace them with %20
  let requestData = createRequestData(
    endpoints.MENUS.ITEM.replace(':storeId', replaceSpace(storeId))
      .replace(':menuId', menuId)
      .replace(':categoryId', categoryId)
      .replace(':itemId', itemId),
    'GET'
  )
  payload = { ...payload, ...requestData }
  return await axios.post(url, payload)
}

// get menus
const getMenus = async (storeId, payload) => {
  let requestData = createRequestData(endpoints.MENUS.MENUS.replace(':storeId', replaceSpace(storeId)), 'GET')
  payload = { ...payload, ...requestData }
  return await axios.post(url, payload)
}

export default {
  getItem,
  getMenus,
}
